import React, { useState } from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export default function Faq() {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAnswer = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const faqTitle = {
        color: '#000',
        textAlign: 'left',
        border: 'none',
        width: '100%',
        padding: '15px 10px !importaint',
        background: '#dddddd26',
        fontSize: '20px',
        fontWeight: '500',
        
       
    }

    const faqanswer = {
        padding: '20px 13px',
        lineHeight: '33px',
        fontSize: '17px',
        borderTop:'1px solid #ddd'
    }


    const faqData = [
        {
            id: "01",
            question: 'What is Udhaarpaisa? ',
            answer: 'Udhaarpaisa is the digital lending platform of AGF, designed to help customers explore and apply for loan products online.',
        },
        {
            id: "02",
            question: 'Who can apply for a loan?',
            answer: 'Eligibility depends on various factors, including age, income, employment profile, and internal credit assessment criteria.',
        },
        {
            id: "03",
            question: 'How is my loan eligibility assessed?',
            answer: 'Eligibility is assessed based on customer information, document verification, internal credit policies, and applicable lending criteria.  ',
        },
        {
            id: "04",
            question: 'How can I track my application status? ',
            answer: 'Customers can track their application status through the platform or by contacting customer support. ',
        },

        {
            id: "05",
            question: 'Is my information secure?',
            answer: ' Yes. Customer information is handled through secure systems and processes in accordance with applicable data protection and regulatory requirements.',
        },
        {
            id: "06",
            question: 'How can I contact customer support? ',
            answer: 'Customers can reach the support team through the contact details provided on the website or through the grievance redressal channels.',
        },
        

    ];

    return (
        <>

            <div className="faq-wrap">
                <div className='text-center'>
                    <p className='tag'>FAQ</p>
                    <h3 className='main-heading'>Frequently Asked Questions</h3>
                </div>

                <div className="faq-list pt-4">
                    {
                        faqData.map((faq, index) => {
                            return (
                                <>
                                    <div className='ms_faq_wrap' key={faq.id}>
                                        <button className='p-2' style={faqTitle} onClick={() => toggleAnswer(index)}>{faq.question}
                                            {openIndex === index ? (
                                                <KeyboardArrowDownIcon style={{ float: 'right' }} />
                                            ) : (
                                                <KeyboardArrowUpIcon style={{ float: 'right' }} />
                                            )}
                                        </button>
                                        {openIndex === index && (
                                            <div style={faqanswer}>
                                              {faq.answer}

                                            </div>
                                        )}
                                    </div>
                                </>
                            )
                        }
                        )
                    }
                </div>
            </div>
        </>
    )
}
